import React, { Component } from 'react'
import './ErrorPage.scss'
import { images } from 'config/images'
import { withRouter } from 'react-router-dom'

class ErrorPage extends Component {
  render() {
    return (
      <div className="ErrorPage__main">
        <div className="ErrorPage__block">
          <div className="ErrorPage__image">
            <img src={images.ico_404} alt="404" />
          </div>
          <div className="empty__text">
            ERROR. Page not found.{' '}
            <span
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                if (this.props.history) this.props.history.replace('/')
              }}
            >
              Go Home
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ErrorPage)
